import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import FailedPrints from "./FailedPrints"
import FailedPrintersSidebar from "./FailedPrintersSidebar"
import FailedPrintersTopbar from "./FailedPrintersTopbar"
import classes from "./index.module.scss"

const FailedPrinters = () => {
  const i18n = useTranslation()[1]

  const [openFailedPrintsSidebar, setOpenFailedPrintsSidebar] = useState(true)
  const [selectedFailedPrinter, setSelectedFailedPrinter] = useState(null)
  const [selectedFailedPrinterIndex, setSelectedFailedPrinterIndex] = useState(null)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <FailedPrintersSidebar
        openFailedPrintsSidebar={openFailedPrintsSidebar}
        setOpenFailedPrintsSidebar={setOpenFailedPrintsSidebar}
        setSelectedFailedPrinter={setSelectedFailedPrinter}
        selectedFailedPrinterIndex={selectedFailedPrinterIndex}
        setSelectedFailedPrinterIndex={setSelectedFailedPrinterIndex}
      />
      <div
        className={clsx(
          classes["wrapper"],
          isLtr && classes["wrapper-ltr"]
        )}
      >
        <FailedPrintersTopbar
          setOpenFailedPrintsSidebar={setOpenFailedPrintsSidebar}
        />
        {
          selectedFailedPrinter !== null &&
          <FailedPrints
            selectedFailedPrinter={selectedFailedPrinter}
            setSelectedFailedPrinter={setSelectedFailedPrinter}
            selectedFailedPrinterIndex={selectedFailedPrinterIndex}
            setSelectedFailedPrinterIndex={setSelectedFailedPrinterIndex}
          />
        }
      </div>
    </Fragment>
  )
}


export default FailedPrinters